import "./ClearProfitStructure.css";
import "../../constants.css";
import { FoodItems, CustomizedGoods } from "./ClearProfitStructureCards";

const Donation = () => {
  return (
    <div className="clear-profit-structure-donation-container">
      <h4>
        Prefer to just{" "}
        <span className="clear-profit-structure-keyword">contribute</span>?
      </h4>
      <p>
        80% of{" "}
        <span className="clear-profit-structure-keyword">contributions</span> go
        to the organization - no products - just support. It's the simplest way
        to help!
      </p>
    </div>
  );
};

const ClearProfitStructure = () => {
  return (
    <div className="clear-profit-structure-container">
      <h2>
        <span style={{ color: "var(--homepage-main-background-1-contrast)" }}>
          Clear
        </span>{" "}
        Profit Structure
      </h2>
      <p>Where your money goes - transparent and impactful</p>

      <div className="container">
        <div className="row">
          <CustomizedGoods />
          <FoodItems />
        </div>

        <div className="row">
          <div className="col-12">
            <Donation />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClearProfitStructure;
